import { formatCurrencyFromCents } from '@/shared/lib/format-utils';

import type { PaidPlan } from '../model/subscription.types';

/** Terms line for the plan cards; null for an unlimited plan. */
export function formatPlanTerms(plan: PaidPlan): string | null {
    // includedSessions is the canonical unlimited marker; overagePriceCents co-travels (both
    // mirror the absent session-limit entry) and checking it narrows the capped branch's type.
    return plan.includedSessions === null || plan.overagePriceCents === null
        ? null
        : `Additional sessions just ${formatCurrencyFromCents(plan.overagePriceCents)} each`;
}
